import styles from '~/shared/components/Hero5050Component/Hero5050Component.module.scss';
import { Link } from '~/shared/components';
import { M12Hero5050Module } from '~/lib/data-contract/auto-generated/api-model';
import { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { DynamicImageLoader } from '~/shared/components/DynamicImageLoader';
import { extractVideoMetadataFromModule } from '~/shared/components/Video/get-video-meta-data';
import { extractVideoSource } from '~/shared/components/Video/get-video-source';
import Hero5050Component from '~/shared/components/Hero5050Component/Hero5050Component';
const Video = dynamic(() => import('~/shared/components/Video/Video'));

type M12Hero5050ModuleProps = M12Hero5050Module;

const M12Hero5050ModuleComponent = (props: M12Hero5050ModuleProps) => {
    const { title, video, image, imageAltText, aboveTheFold, link } = props;

    const videoSource = extractVideoSource(video, props);

    const media = useMemo(() => {
        if (videoSource) {
            return (
                <div className={styles.linkWrapper}>
                    <Video
                        name={title}
                        muted={videoSource.mute}
                        controls={false}
                        src={videoSource.src}
                        loop={videoSource.loop}
                        playing={videoSource.autoPlay}
                        posterSrc={image?.src}
                        cover
                        theaterMode={videoSource.theaterMode}
                        metadata={extractVideoMetadataFromModule(props)}
                    />
                </div>
            );
        }

        if (!image?.src) return null;

        const imageElement = (
            <DynamicImageLoader
                className={styles.image}
                src={image?.src ?? ''}
                width={520}
                height={390}
                alt={imageAltText ?? ''}
                priority={aboveTheFold}
            />
        );

        if (link?.url) {
            return (
                <Link
                    title={link.title}
                    noHover
                    href={link.url}
                    target={link.target}
                    className={styles.linkWrapper}
                >
                    {imageElement}
                </Link>
            );
        }

        return <div className={styles.linkWrapper}>{imageElement}</div>;
    }, [aboveTheFold, image?.src, imageAltText, link, title, videoSource?.src]);

    return <Hero5050Component {...props} media={media} />;
};

export default M12Hero5050ModuleComponent;
